var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',{staticClass:"font-background-icon",attrs:{"color":"var(--palette-unchanged-bg)","font-size":24},on:{"click":_vm.changeBackgroundState}},[_vm._v(_vm._s(_vm.renderIcon))])}
var staticRenderFns = []

export { render, staticRenderFns }